import { createEntityAdapter } from '@reduxjs/toolkit';
import { IFarmDTO } from '@halter-corp/business-service-client';

const farmAdapter = createEntityAdapter<IFarmDTO>({
  selectId: (farm) => farm.id,
});

export default farmAdapter;
